import { UserManagerSettings } from 'oidc-client-ts';

/**
 * OIDC設定
 * AWS Cognitoとの統合用設定
 */
export const oidcConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}/auth/signin`,
  scope: import.meta.env.VITE_OIDC_SCOPE || 'openid email profile',
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: true,
  // PKCEフローを使用するため、client_secretは不要
  // CognitoのPublic Client設定に対応
};
